import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectHomeVisionJobTypeSettings = createSelector(
  getSystem,
  ({ homeVisionJobTypeSettings }) => homeVisionJobTypeSettings,
);

export const selectHomeVisionJobTypeSettingsValues = createSelector(
  selectHomeVisionJobTypeSettings,
  Object.values,
);

export const selectFilteredHomeVisionJobTypeSettings = createSelector(
  getDebouncedSearchValue,
  selectHomeVisionJobTypeSettingsValues,
  searchItems(({ label, value }) => [label, value]),
);
